import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { goldTypes } from '@/mocks/goldPrices';

export default function Utilities() {
  const [weight, setWeight] = useState(1);
  const [goldId, setGoldId] = useState(goldTypes[0].id);
  const selected = goldTypes.find((g) => g.id === goldId) ?? goldTypes[0];

  const pricePerChi = selected.sell / 10;
  const value = weight * selected.sell;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="border-b border-background-200/60 bg-background-100">
          <div className="mx-auto max-w-5xl px-4 md:px-6 py-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">Trang tiện ích</h1>
            <p className="mt-2 text-foreground-600">Các công cụ hỗ trợ nhà đầu tư vàng.</p>
          </div>
        </div>

        <div className="mx-auto max-w-5xl px-4 md:px-6 py-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="rounded-xl border border-background-200/60 bg-background-100 p-6">
              <h2 className="text-base font-semibold text-foreground-950 mb-5">Máy tính giá vàng</h2>
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Loại vàng</label>
                  <select value={goldId} onChange={(e) => setGoldId(e.target.value)} className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500">
                    {goldTypes.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Khối lượng (lượng)</label>
                  <input type="number" min="0.1" step="0.1" value={weight} onChange={(e) => setWeight(Number(e.target.value))} className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
                </div>
                <div className="rounded-lg bg-background-50 p-4 space-y-2">
                  <div className="flex justify-between text-sm"><span className="text-foreground-600">Giá bán / lượng</span><span className="font-semibold text-foreground-950">{selected.sell.toLocaleString('vi-VN')}đ</span></div>
                  <div className="flex justify-between text-sm"><span className="text-foreground-600">Giá bán / chỉ</span><span className="font-semibold text-foreground-950">{pricePerChi.toLocaleString('vi-VN')}đ</span></div>
                  <div className="flex justify-between text-sm pt-2 border-t border-background-300/40"><span className="text-foreground-600">Tổng giá trị</span><span className="font-semibold text-gold-gradient">{value.toLocaleString('vi-VN')}đ</span></div>
                </div>
              </div>
            </div>

            <div className="rounded-xl border border-background-200/60 bg-background-100 p-6">
              <h2 className="text-base font-semibold text-foreground-950 mb-5">Quy đổi đơn vị vàng</h2>
              <div className="space-y-3">
                {[
                  { unit: '1 lượng (cây)', value: '= 37,5 gram' },
                  { unit: '1 chỉ', value: '= 3,75 gram' },
                  { unit: '1 phân', value: '= 0,375 gram' },
                  { unit: '1 kg vàng', value: '≈ 26,67 lượng' },
                  { unit: '1 ounce', value: '= 31,10 gram' },
                ].map((r) => (
                  <div key={r.unit} className="flex items-center justify-between rounded-lg bg-background-50 px-4 py-3">
                    <span className="text-sm text-foreground-800">{r.unit}</span>
                    <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{r.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-background-200/60 bg-background-100 p-6 mt-6">
            <h2 className="text-base font-semibold text-foreground-950 mb-2">Lưu ý khi giao dịch vàng</h2>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex gap-2"><i className="ri-check-line text-primary-400 mt-0.5"></i> Luôn xác minh danh tính trước khi nạp/rút tiền.</li>
              <li className="flex gap-2"><i className="ri-check-line text-primary-400 mt-0.5"></i> Theo dõi biến động giá trước khi đặt lệnh mua bán.</li>
              <li className="flex gap-2"><i className="ri-check-line text-primary-400 mt-0.5"></i> Không chia sẻ mật khẩu, mã OTP với bất kỳ ai.</li>
              <li className="flex gap-2"><i className="ri-check-line text-primary-400 mt-0.5"></i> Giá vàng có thể biến động, cân nhắc kỹ trước khi giao dịch.</li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}